var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9029 12.8163L4.46712 0.711531L20.2891 9.52908L16.9029 12.8163ZM1.22249 0C0.489535 0.371956 0 1.05023 0 1.93067V26.0693C0 26.9498 0.490437 27.628 1.22249 28L15.6814 13.9969L1.22249 0ZM25.18 12.3402L21.8614 10.4752L18.1597 14.0031L21.8614 17.531L25.2476 15.6659C26.2618 14.8844 26.2618 13.1226 25.18 12.3402ZM4.46802 27.2955L20.29 18.4779L16.9038 15.1907L4.46802 27.2955Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.7f8ca31eeb196c1fc299a998f80aca9e.svg";
export { ForwardRef as ReactComponent };